// * Este contexto nos indica si el menu verical esta mostrándose o no *

import {useState, createContext} from 'react'

// Creo el contexto con la data default si no tiene acceso, es decir si no envuelve el componente 
const MenuContext = createContext({messsage: 'No tienes acceso a exte contexto.'})

// Creo mi provider del contexto creado ya 
export const MenuContextProvider = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <MenuContext.Provider value={{isMenuOpen, setIsMenuOpen}}>
        {children}
    </MenuContext.Provider>
  )
}

export default MenuContext
